// ════════════════════════════════════════════════════════════════
// Helpers API Platform (génériques, réutilisables dans tout Qualifop)
// ════════════════════════════════════════════════════════════════
// Remplace le nettoyage d'IRI fait à la main dans plusieurs stores
// (ex. `actionId.split('/').pop()` dans antenneActions).

// L'API Qualifop n'a PAS de préfixe de route : les IRI sont de la forme
// "/antennes/124" (cf. "@context": "/contexts/Error", request_uri
// "/type_prospections"). Le "/api" vu côté front vient de la baseURL
// d'ApiService, il ne fait pas partie de l'IRI.
export const IRI_PREFIX = ''

export const iri = (resource, id) => `${IRI_PREFIX}/${resource}/${id}`

/** Accepte un id, un IRI ("/api/users/12") ou un objet ({ id } / { '@id' }). */
export const extractId = (value) => {
  if (value === null || value === undefined || value === '') return null
  if (typeof value === 'number') return value
  if (typeof value === 'object') return value.id ?? extractId(value['@id'])
  const last = String(value).split('/').filter(Boolean).pop()
  return /^\d+$/.test(last) ? Number(last) : last
}

export const toIri = (value, resource) => {
  if (value === null || value === undefined || value === '') return null
  if (typeof value === 'object' && value['@id']) return value['@id']
  if (typeof value === 'string' && value.includes('/')) return value
  const id = extractId(value)
  return id === null ? null : iri(resource, id)
}

/** Réponse application/json (tableau) ou application/ld+json (hydra). */
export const unwrap = (data) => (Array.isArray(data) ? data : (data?.['hydra:member'] ?? []))

/** "date_echeance" → "dateEcheance" (l'API sérialise en snake_case). */
export const toCamel = (key) => String(key).replace(/_([a-z0-9])/g, (_, c) => c.toUpperCase())

/** Violations de validation (422) → { proprieteEnCamelCase: message } */
export const extractViolations = (error) =>
  (error?.response?.data?.violations ?? []).reduce((acc, v) => {
    const key = v.propertyPath ? toCamel(v.propertyPath) : null
    if (key && !acc[key]) acc[key] = v.message
    return acc
  }, {})

export const extractMessage = (error, fallback) =>
  error?.response?.data?.['hydra:description'] ??
  error?.response?.data?.detail ??
  fallback
